import { render, staticRenderFns } from "./SettingModalNew.vue?vue&type=template&id=8531f078&scoped=true&"
import script from "./SettingModalNew.vue?vue&type=script&lang=js&"
export * from "./SettingModalNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingModalNew.vue?vue&type=style&index=0&id=8531f078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531f078",
  null
  
)

export default component.exports